export function ResolvePlanPreview({ status }: { status: string }) {
  if (status === 'resolved') return <p className="mt-2 text-xs text-muted-foreground">Resolved · reopen if the owner’s answer changed.</p>;
  return <p className="mt-2 text-xs text-muted-foreground">Resolving will keep the owner answer and linked evidence with this item.</p>;
}

